export const Flags = (): Array<string> => ([
  'Malaria',
  'Yellow Fever'
]);
